import { Injectable } from '@angular/core';
import { BackendService } from 'core-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  constructor(private backendSvc: BackendService) { }

  public lookupCode(activationCode: string, userName: string): Observable<ActivationCodeLookupResponseData> {
    let url = environment.lookupActivationCodeUrl + '/' + activationCode + '?userName=' + userName;

    return this.backendSvc.get(url)
      .pipe(map((n: ActivationCodeLookupResponse) => {
        return n.data;
      })
      );
  }


  public activateAccount(activationCode: string, data: ActivateAccountRequest): Observable<boolean> {
    
    let url = environment.activateAccountUrl + '/' + activationCode;

    return this.backendSvc.put(url, data)
      .pipe(map((n: ActivateAccountResponse) => {
        return true;
      })
      );
  }

  public submitApplication(data: ApplicationDetails): Observable<CreateApplicationResponseData> {

    return this.backendSvc.post(environment.applicationCreateUrl, data).pipe(map((n: CreateApplicationResponse) => {
      return n.data;
    }));

  }

  public lookupUsername(username: string): Observable<LookupUsernameResponseData> {

    let url = environment.applicationLookupUsernameUrl + '/' + encodeURI(username);

    return this.backendSvc.get(url).pipe(map((n: LookupUsernameResponse) => {
      return n.data;
    }));

  }

  public validateRego(rego: string, state: string): Observable<ValidateRegoReponseData> {

    let url = `${environment.applicationValidateRegoUrl}/${encodeURI(state)}/${rego}`;

    return this.backendSvc.get(url).pipe(map((n: ValidateRegoReponse) => {
      return n.data;
    }));

  }


  public getApplicationLOVs(): Observable<ApplicationLOVsResponseData> {
    let url = environment.applicationLOVsUrl;

    return this.backendSvc.get(url).pipe(map((n: ApplicationLOVsResponse) => {
      return n.data;
    }));

  }

 
}

class ApplicationLOVsResponse {
  public code: number;
  public message: string;
  public data: ApplicationLOVsResponseData;
}

export class ApplicationLOVsResponseData {
  public usageRate: number;
  public permitRate: number;
  public businessTypes: ApplicationBusinessTypeItem[];
  public vehicleTypes: ApplicationVehicleTypeItem[];
  public vehicleMakes: ApplicationVehicleMakeItem[];
}

export class ApplicationBusinessTypeItem {
  public businessTypeId: string;
  public description: string;
}
export class ApplicationVehicleTypeItem {
  public vehicleTypeId: string;
  public description: string;
  public isActive: boolean;
}

export class ApplicationVehicleMakeItem {
  public vehicleMakeId: string;
  public description: string;
  public isActive: boolean;
}
class ValidateRegoReponse {
  public code: number;
  public message: string;
  public data: ValidateRegoReponseData;
}

export class ValidateRegoReponseData {
  public isValid: boolean;
  public existingVehicles: any[];
}

class ActivationCodeLookupResponse {
  public code: number;
  public message: string;
  public data: ActivationCodeLookupResponseData;
}

export class ActivationCodeLookupResponseData {
  public exists: boolean;
  public isActivated: boolean;
  public isPasswordSet: boolean;
}

class ActivateAccountResponse {
  public code: number;
  public message: string;
}

export class ActivateAccountRequest {
  public activationCode: string;
  public userName: string;
  public password: string;
}




export class LookupUsernameResponse {
  public code: number;
  public message: string;
  public data: LookupUsernameResponseData;
}

export class LookupUsernameResponseData {
  public exists: boolean;
}

export class ApplicationDetails {
  public clientName: string;
  public firstName: string;
  public lastName: string;
  public abn: string;
  
  public address1: string;
  public address2: string;
  public suburb: string;
  public state: string;
  public postCode: string;
  public isAddressNotFound: boolean;

  public billingAddress1: string;
  public billingAddress2: string;
  public billingSuburb: string;
  public billingState: string;
  public billingPostCode: string;
  public isBillingAddressNotFound: boolean;

  public isSameAddress: boolean;

  public email: string;
  public mobilePhone: string;
  public workPhone: string;

  public businessTypeId: string;
  public businessTypeOther: string;
  public isEmsKey: boolean;
  public startDate: string;
  public isAdminCreated: boolean;

  public vehicles: ApplicationVehicle[];
}

export class ApplicationVehicle {
  public vehicleId: string;
  public regoNo: string;
  public regoState: string;
  public capacity: number;
  public isAirGap: boolean;
  public isRPZD: boolean;
  public vehicleTypeId: string;
  public vehicleMakeId: string;
  public backflowPreventionCertificateIssueDate: string;
}

export class CreateApplicationResponse {
  public code: number;
  public message: string;
  public data: CreateApplicationResponseData;
}

export class CreateApplicationResponseData {
  public permitId: string;
  public username: string;
  public activationCode: string;
  public isDuplicatePermitHolder: boolean;
}
